import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import  HepServiceApi from "../../../api/hep/hep-screen-api";
import { IGetRequestHepResponse, } from "../../../api/hep/hep-screen-model";


export interface IRequestsSlice {
  requestsData: IGetRequestHepResponse | null;
  loading: boolean;
  error: any;
  status: string;
}

const INITIAL_STATE = {
  requestsData: null,
  loading: false,
  error: null,
  status: "idle",
} as IRequestsSlice;

export const getRequestsData = createAsyncThunk(
  "hep/getRequestsData",
  HepServiceApi.getRequests
);

export const _resetRequestData = createAction('/hep/resetRequestData');

const requestsDataSlice = createSlice({
  name: "getRequestsData",
  initialState: INITIAL_STATE,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRequestsData.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(getRequestsData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.requestsData = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(getRequestsData.rejected, (state, action) => {
        state.loading = false;
        state.requestsData = null;
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(_resetRequestData, (state) => {
        state.requestsData = null;
        state.loading = false;
        state.error = null;
        state.status = "idle";
      });
  },
});

export default requestsDataSlice;
